module.exports = __webpack_public_path__ + "static/media/amarant-logo.751d7872.svg";